import React, { useState, useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { IClub } from "@eagerdog/interfaces";
import { apiService } from "src/services";

import ScheduleTab from "src/routes/KennelClub/components/ScheduleTab/ScheduleTab";

import styles from "./EmbedCalendar.module.scss";

const EmbedCalendar: React.FC = () => {
  const { clubId } = useParams<{ clubId: string }>();
  const [club, setClub] = useState<IClub | undefined>(undefined);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const [searchParams] = useSearchParams();
  const primaryColor        = searchParams.get("primaryColor");
  const secondaryColor      = searchParams.get("secondaryColor");
  const coursePrimaryColor  = searchParams.get("coursePrimaryColor");
  const courseSecondaryColor = searchParams.get("courseSecondaryColor");
  const bgColor             = searchParams.get("bgColor");

  useEffect(() => {
    if (!clubId) return;
    apiService.getClub(clubId)
      .then((c: IClub) => {
        setClub(c);
        setLoading(false);
      })
      .catch(() => {
        setError(true);
        setLoading(false);
      });
  }, [clubId]);

  if (loading) {
    return <div className={styles.state}>Loading…</div>;
  }

  if (error || !club) {
    return <div className={styles.state}>Calendar not available.</div>;
  }

  return (
    <div
      className={styles.EmbedCalendar}
      style={
        {
          "--embed-primary":          primaryColor        || undefined,
          "--embed-secondary":        secondaryColor      || undefined,
          "--embed-course-primary":   coursePrimaryColor  || undefined,
          "--embed-course-secondary": courseSecondaryColor || undefined,
          "--embed-bg":               bgColor             || undefined,
        } as React.CSSProperties
      }
    >
      <ScheduleTab club={club} isAdmin={false} onEventCreate={() => {}} />
      <div className={styles.attribution}>
        <a href="https://eagerdog.com" target="_blank" rel="noopener noreferrer">
          Powered by Eager Dog
        </a>
      </div>
    </div>
  );
};

export default EmbedCalendar;
